import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { AiFillEdit, AiFillEye } from "react-icons/ai";

const AgentsTable = (props) => {

  const t = props.t;

  return (
    <div>
      <Table striped responsive>
        <thead className='bg-primary text-white'>
          <tr>
            <th>{t('commercial_network.commercial')}</th>
            <th>{t('commercial_network.code')}</th>
            <th>{t('commercial_network.name')}</th>
            <th>{t('commercial_network.address')}</th>
            <th>{t('commercial_network.city')}</th>
            <th>{t('commercial_network.balance')}</th>
            <th>{t('commercial_network.credit')}</th>
          </tr>
        </thead>
        <tbody>
          {props.agents.map((agent) => (
            <tr key={agent.id}>
              <td> {agent.seller[0].user.name} </td>
              <td> {agent.income_code} </td>
              <td> {agent.registered_business_name.substring(0, 30)} </td>
              <td> {agent.active_location_model.address1.substring(0, 30)} </td>
              <td> {agent.active_location_model.city} </td>
              <td> {parseFloat(agent.balance).toFixed(2)} </td>
              <td> {parseFloat(agent.credit).toFixed(2)} </td>
              <td>
                <Link to={`/commercial_network/agents/edit/${agent.id}`}>  <AiFillEdit /> </Link>
              </td>
              <td>
                <Link to={`/commercial_network/agents/show/${agent.id}`}>  <AiFillEye /> </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AgentsTable;